import { Flex } from 'antd';
import { useParams } from 'react-router-dom';
import { ChargeDetail } from '~/app/components/session/ChargeDetail/ChargeDetail';

export function SessionChargePage() {
  const { chargeId = '' } = useParams<{ chargeId: string }>();

  return (
    <Flex vertical gap={16} className="app-page">
      <ChargeDetail chargeId={chargeId} />
    </Flex>
  );
}
